import request from "root/js/request";

export const getAdvertDynamicOzon = async ({ wb_api_key_ids, date_from, date_to, ...rest }) => {
  const response = await request({
    url: "/ozon_analytics/advert_dynamic/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      ...rest,
    },
  });
  return response.data;
};
